// The Operator's Acasă — the same page as the Registrar Administrator's, scoped to
// the one location they report for.
//
// `wireframes/react/src/pages/Acasa.tsx:210`: with exactly one location the band asks
// whether "I" have reported today, and its actions follow that answer.
//
// The greeting and the four-card grid this used to open with appear on no role in the
// wireframe. A draft in progress is the band's to announce and continue.
import { ReporterHome } from '../ReporterHome';

export function OperatorHome(): JSX.Element {
  return <ReporterHome rolePrefix="/operator" oversees={false} />;
}
